exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".gray[data-v-00503712] {\n  color: #afafaf;\n}\n", ""]);

// exports
